import React, { useContext } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import HelpTitulo from "./HelpTitulo";
import IsMobileContext from "../context/isMobile/isMobileContext";
import Link from "@material-ui/core/Link";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  tittle: {
    position: "sticky",
    marginTop: "0px",
    marginBottom: "0px",
    width: "100%",
    fontWeight: 10,
    fontSize: 24, // 24
    color: "#000000",
  },
  tittle2: {
    position: "sticky",
    marginTop: "0px",
    marginBottom: "0px",
    width: "100%",
    fontWeight: 100,
    fontSize: 16, // 16
    color: "#000000",
  },
}));

export default function Titulo(props) {
  const history = useHistory();
  const classes = useStyles();
  const isMobile = useContext(IsMobileContext);
  const { isMobileUse } = isMobile;
  const redir = (x) => {
    if (x !== "/dashboard") {
      history.push(x);
    } else {
      window.location.href = "/dashboard";
    }
  };
  return (
    <div style={{ width: "100%" }}>
      {isMobileUse() ? (
        props.direccion ? (
          props.children.length == 2 ? (
            <>
              <Breadcrumbs separator=" / " aria-label="breadcrumb">
                <h1 className={classes.tittle2}>{props.children[1]}</h1>
              </Breadcrumbs>
              <hr color="#E5E5E5" size="2" width="100%" />
            </>
          ) : props.children.length == 3 ? (
            <>
              <Breadcrumbs separator=" / " aria-label="breadcrumb">
                <h1 className={classes.tittle2}>{props.children[2]}</h1>
              </Breadcrumbs>
              <hr color="#E5E5E5" size="2" width="100%" />
            </>
          ) : props.children.length == 4 ? (
            <>
              <Breadcrumbs
                separator=" / "
                aria-label="breadcrumb"
                className={classes.tittle2}
              >
                <h1 className={classes.tittle2}>{props.children[3]}</h1>
              </Breadcrumbs>
              <hr color="#E5E5E5" size="2" width="100%" />
            </>
          ) : null
        ) : props.children.length == 2 ? (
          <>
            <Breadcrumbs separator=" / " aria-label="breadcrumb">
              <h1 className={classes.tittle}>{props.children[0]}</h1>
              <h1 className={classes.tittle} style={{ fontSize: 26 }}>
                {props.children[1]}
              </h1>
            </Breadcrumbs>
            <hr color="#E5E5E5" size="2" width="100%" />
          </>
        ) : props.children.length == 3 ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Breadcrumbs separator=" / " aria-label="breadcrumb">
                <h1 className={classes.tittle}>{props.children[0]}</h1>
                <h1 className={classes.tittle}>{props.children[1]}</h1>
                <h1 className={classes.tittle} style={{ fontSize: 26 }}>
                  {props.children[2]}
                </h1>
              </Breadcrumbs>
            </div>
            <hr color="#E5E5E5" size="2" width="100%" />
          </>
        ) : (
          <>
            <h1 className={classes.tittle}>{props.children}</h1>
            <hr color="#E5E5E5" size="2" width="100%" />
          </>
        )
      ) : props.direccion ? (
        props.children.length == 2 ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Breadcrumbs separator=" / " aria-label="breadcrumb">
                <Link
                  onClick={() => redir(props.direccion)}
                  style={{ cursor: "pointer", fontSize: 18.5 }}
                >
                  <h1 className={classes.tittle}>{props.children[0]}</h1>
                </Link>
                <h1 className={classes.tittle} style={{ fontSize: 26 }}>
                  {props.children[1]}
                </h1>
              </Breadcrumbs>
              { props.descripcion && 
                <HelpTitulo descripcion={props.descripcion} />
              }
            </div>
            <hr color="#E5E5E5" size="2" width="100%" />
          </>
        ) : props.children.length == 3 ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Breadcrumbs separator=" / " aria-label="breadcrumb">
                <Link
                  onClick={() => redir(props.direccion)}
                  style={{ cursor: "pointer", fontSize: 18.5 }}
                >
                  <h1 className={classes.tittle}>{props.children[0]}</h1>
                </Link>
                <Link
                  underline="none"
                  onClick={() => history.push(props.direccion1)}
                  style={{ cursor: "default", fontSize: 18.5 }}
                >
                  <h1 className={classes.tittle}>{props.children[1]}</h1>
                </Link>
                <h1 className={classes.tittle} style={{ fontSize: 26 }}>
                  {props.children[2]}
                </h1>
              </Breadcrumbs>
              { props.descripcion && 
                <HelpTitulo descripcion={props.descripcion} />
              }
            </div>
            <hr color="#E5E5E5" size="2" width="100%" />
          </>
        ) : props.children.length == 4 ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Breadcrumbs
                separator=" / "
                aria-label="breadcrumb"
                className={classes.tittle}
              >
                <Link
                  color="inherit"
                  onClick={() => redir(props.direccion)}
                  style={{ cursor: "pointer", fontSize: 18.5 }}
                >
                  <h1 className={classes.tittle}>{props.children[0]}</h1>
                </Link>
                <Link
                  color="inherit"
                  underline="none"
                  onClick={() => history.push(props.direccion1)}
                  style={{ cursor: "default", fontSize: 18.5 }}
                >
                  <h1 className={classes.tittle}>{props.children[1]}</h1>
                </Link>
                <Link
                  color="inherit"
                  underline="none"
                  onClick={() => history.push(props.direccion1)}
                  style={{ cursor: "default", fontSize: 18.5 }}
                >
                  <h1 className={classes.tittle}>{props.children[2]}</h1>
                </Link>
                <h1 className={classes.tittle} style={{ fontSize: 26 }}>
                  {props.children[3]}
                </h1>
              </Breadcrumbs>
              { props.descripcion && 
                <HelpTitulo descripcion={props.descripcion} />
              }
            </div>
            <hr color="#E5E5E5" size="2" width="100%" />
          </>
        ) : null
      ) : props.children.length == 2 ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Breadcrumbs separator=" / " aria-label="breadcrumb">
              <h1 className={classes.tittle}>{props.children[0]}</h1>
              <h1 className={classes.tittle}>
                {props.children[1]}
              </h1>
            </Breadcrumbs>
            { props.descripcion && 
                <HelpTitulo descripcion={props.descripcion} />
              }
          </div>
          <hr color="#E5E5E5" size="2" width="100%" />
        </>
      ) : props.children.length == 3 ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Breadcrumbs separator=" / " aria-label="breadcrumb">
              <h1 className={classes.tittle}>{props.children[0]}</h1>
              <h1 className={classes.tittle}>{props.children[1]}</h1>
              <h1 className={classes.tittle} style={{ fontSize: 26 }}>
                {props.children[2]}
              </h1>
            </Breadcrumbs>
            { props.descripcion && 
                <HelpTitulo descripcion={props.descripcion} />
              }
          </div>
          <hr color="#E5E5E5" size="2" width="100%" />
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h1 className={classes.tittle}>{props.children}</h1>
            { props.descripcion && 
                <HelpTitulo descripcion={props.descripcion} />
              }
          </div>
          <hr color="#E5E5E5" size="2" width="100%" />
        </>
      )}
    </div>
  );
}
Titulo.propTypes = {
  children: PropTypes.node,
};
